import { createContext, FunctionComponent, ReactNode, useState } from 'react';

import { Alert, AlertColor, Snackbar, ThemeProvider } from '@mui/material';

import { SnackBarContextModel } from './models/snack-bar-context.model';
import { snackBarTheme } from './theme/snack-bar.theme';

export const SnackBarContext = createContext<SnackBarContextModel | null>(null);

const SnackBarContextProvider: FunctionComponent = ({
  children,
}): JSX.Element => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [autoHide, setAutoHide] = useState<number>(2000);
  const [message, setMessage] = useState<string>('');
  const [severity, setSeverity] = useState<AlertColor>('success');
  const [icon, setIcon] = useState<boolean | ReactNode | undefined>(false);

  const changeOpenState = (open: boolean): void => {
    setIsOpen(open);
  };

  const handleClose = (): void => {
    setIsOpen(false);
  };

  const changeAutoHide = (time: number): void => {
    setAutoHide(time);
  };

  const changeMessage = (msg: string): void => {
    setMessage(msg);
  };

  const changeSeverity = (svr: AlertColor): void => {
    setSeverity(svr);
  };

  const changeIcon = (iconState?: boolean | ReactNode): void => {
    setIcon(iconState);
  };

  return (
    <SnackBarContext.Provider
      value={{
        open: isOpen,
        isOpen: changeOpenState,
        onClose: handleClose,
        autoHideDuration: autoHide,
        changeAutoHide,
        message,
        changeMessage,
        severity,
        changeSeverity,
        icon,
        changeIcon,
      }}
    >
      <>
        {children}

        <ThemeProvider theme={snackBarTheme}>
          <Snackbar
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            open={isOpen}
            onClose={handleClose}
            autoHideDuration={autoHide}
          >
            <Alert
              severity={severity}
              className={severity}
              classes={{ icon: 'alert-icon' }}
              icon={icon}
            >
              {message}
            </Alert>
          </Snackbar>
        </ThemeProvider>
      </>
    </SnackBarContext.Provider>
  );
};

export default SnackBarContextProvider;
